import React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MailIcon from "@mui/icons-material/Mail";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import useStyles, { NavbarLogo, NavbarLink } from "./styles";
import "./styles.css";
import logo from "../../assets/images/logo.png";
import ProfileImg from "../../assets/images/ProfileImg.jpeg";
import FormInputNoLabel from "../FormInputNoLabel/FormInputNoLabel";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  Person,
  ShoppingCart,
  Notifications,
  Group,
  Logout,
  Dashboard,
  Inventory,
  LocalShipping,
  SignalCellularAlt,
  Report,
  Forum,
  ViewCarousel,
  ExpandLess,
  ExpandMore,
  Message,
  ColorLens,
  Pageview,
  Checkroom,
  Settings,
  History,
  VpnKey,
  Sync,
  Lock,
  Image,
  LinearScale,
  Archive,
} from "@mui/icons-material";
import { Collapse } from "@mui/material";
import Paragraph from "../Typography/Paragraph";
import useUser from "../../hooks/useUser";
import { get_sales_order_report } from "../../API/API";

const drawerWidth = 240;

const Navbar2 = ({ children, ...props }) => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [issuesCount, setIssuesCount] = React.useState(0);

  const defaultPage = {
    dashboard: false,
    sale: false,
    editcart: false,
    salereport: false,
    inventory: false,
    razerlog: false,
    customer: false,
    admin: false,
    shipping: false,
    color: false,
    material: false,
    apparel: false,
    decoration: false,
    brand: false,
    decorative: false,
    custommadeenquiry: false,
    customerenquiry: false,
    banner: false,
  };

  const handleMouseEnter = (key) => {
    setIsShown({
      ...defaultPage,
      [key]: true,
    });
  };

  const handleMouseLeave = () => {
    setIsShown(defaultPage);
  };

  const [isShown, setIsShown] = React.useState({ ...defaultPage });

  const { set_user, get_user } = useUser();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [open, setOpen] = React.useState(
    location.pathname.replace(/[^A-Za-z]+/g, "") === "banner" ? true : false
  );
  const [openUser, setOpenUser] = React.useState(
    location.pathname.replace(/[^A-Za-z]+/g, "") === "dashboard" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "sale" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "saledetail" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "editcart" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "createorder" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "salereturn" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "salereturnlist" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "salereport" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "salereportdetail" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "inventory" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "inventorydetail" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "razerlog" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "customer" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "customerdetail" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "admin" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "admindetail" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "setting"
      ? true
      : false
  );
  const [openSetting, setOpenSetting] = React.useState(
    location.pathname.replace(/[^A-Za-z]+/g, "") === "shipping" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "color" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "material" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "apparel" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "decoration" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "decorative" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "brand"
      ? true
      : false
  );
  const [openEnquiry, setOpenEnquiry] = React.useState(
    location.pathname.replace(/[^A-Za-z]+/g, "") === "custommadeenquiry" ||
      location.pathname.replace(/[^A-Za-z]+/g, "") === "customerenquiry"
      ? true
      : false
  );

  const handleClick = () => {
    setOpen(!open);
  };

  const handleClickUser = () => {
    setOpenUser(!openUser);
  };

  const handleClickSetting = () => {
    setOpenSetting(!openSetting);
  };

  const handleClickEnquiry = () => {
    setOpenEnquiry(!openEnquiry);
  };

  const getData = () => {
    var _data = [];
    get_sales_order_report({
      // sort: sort
    }).then((json) => {
      if (json.status) {
        for (var i = 0; i < json.data.length; i++) {
          if (json.data[i].is_solved == 0) {
            _data.push(json.data[i]);
          }
        }
        setIssuesCount(json.total);
      }
    });
  };

  const handleLogout = () => {
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("dateto");
    window.localStorage.removeItem("datefrom");
    window.localStorage.removeItem("status");
    window.localStorage.removeItem("salerep");
    window.localStorage.removeItem("issuelog_status");
    window.localStorage.removeItem("issuelog_datefrom");
    window.localStorage.removeItem("issuelog_dateto");
    window.localStorage.removeItem("filterDataSales");
    window.localStorage.removeItem("country");
    navigate("/");
    set_user(null);
  };

  React.useEffect(() => {
    if (get_user() === null) {
      handleLogout();
    }
    getData();
  }, []);

  const handleHoverTrue = (e) => {
    if (e == "dashboard") {
      setIsShown({
        ...isShown,
        dashboard: true,
      });
    }
  };

  const drawer = (
    <div>
      <Toolbar />
      {/* <Divider /> */}
      <Box sx={{ overflow: "auto", padding: "2rem 1rem" }}>
        <div
          className={classes.theAccount}
          onClick={() => navigate("../setting")}
        >
          <div>
            <Paragraph
              size="14px"
              color="#000"
              bold="600"
              textTransform="capitalize"
              // margin='0 0 6px'
            >
              {get_user() !== null && get_user().username}
            </Paragraph>
            <Paragraph
              size="14px"
              color="#000"
              // bold='600'
              textTransform="capitalize"
            >
              {get_user() !== null && get_user().name}
            </Paragraph>
          </div>
          <div className={classes.theAImg}>
            <Settings style={{ color: "#000", fontSize: "1.2rem" }} />
            {/* <img src={ProfileImg} alt={ProfileImg} /> */}
          </div>
          {/* <div
            style={{
              position: "absolute",
              left: "6px",
              bottom: "6px"
            }}
          >
            <Settings style={{ color: "#1A5386", fontSize: "1.2rem" }} />
          </div> */}
        </div>

        {get_user().role_id == 3 ? (
          <List>
            <ListItem
              onMouseEnter={() => handleMouseEnter("inventory")}
              onMouseLeave={() => handleMouseLeave()}
              style={{
                alignItems: "center",
                display: "flex",
                marginBottom: "0",
                padding: "10px 30px",
                borderRadius: "10px",
                backgroundColor:
                  location.pathname.replace(/[^A-Za-z]+/g, "") ===
                    "inventory" ||
                  location.pathname.replace(/[^A-Za-z]+/g, "") ===
                    "inventorydetail" ||
                  isShown.inventory == true
                    ? "#1A5386"
                    : "#fff",
              }}
            >
              <Inventory
                style={{
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "inventory" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "inventorydetail" ||
                    isShown.inventory == true
                      ? "#fff"
                      : "#1A5386",
                }}
              />
              <a
                style={{
                  textDecoration: "none",
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "inventory" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "inventorydetail" ||
                    isShown.inventory == true
                      ? "#fff"
                      : "#1A5386",
                  width: "100%",
                  marginLeft: "1rem",
                }}
                href="/inventory"
              >
                <ListItemText
                  primary="Inventory"
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "inventory" ||
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "inventorydetail" ||
                      isShown.inventory == true
                        ? "#fff"
                        : "#1A5386",
                    fontWeight: "700 !important",
                  }}
                />
              </a>
            </ListItem>
          </List>
        ) : (
          <List>
            <ListItem
              onMouseEnter={() => handleMouseEnter("dashboard")}
              onMouseLeave={() => handleMouseLeave()}
              style={{
                alignItems: "center",
                display: "flex",
                marginBottom: "0",
                padding: "10px 30px",
                borderRadius: "10px",
                backgroundColor:
                  location.pathname.replace(/[^A-Za-z]+/g, "") ===
                    "dashboard" || isShown.dashboard == true
                    ? "#1A5386"
                    : "#fff",
              }}
            >
              <Dashboard
                style={{
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "dashboard" || isShown.dashboard == true
                      ? "#fff"
                      : "#1A5386",
                }}
              />
              <a
                style={{
                  textDecoration: "none",
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "dashboard" || isShown.dashboard == true
                      ? "#fff"
                      : "#1A5386",
                  width: "100%",
                  marginLeft: "1rem",
                }}
                href="/dashboard"
              >
                <ListItemText
                  primary="Dashboard"
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "dashboard" || isShown.dashboard == true
                        ? "#fff"
                        : "#1A5386",
                    fontWeight: "700 !important",
                  }}
                />
              </a>
            </ListItem>
            <ListItem
              onMouseEnter={() => handleMouseEnter("sale")}
              onMouseLeave={() => handleMouseLeave()}
              style={{
                alignItems: "center",
                display: "flex",
                marginBottom: "0",
                padding: "10px 30px",
                borderRadius: "10px",
                backgroundColor:
                  location.pathname.replace(/[^A-Za-z]+/g, "") === "sale" ||
                  location.pathname.replace(/[^A-Za-z]+/g, "") ===
                    "saledetail" ||
                  location.pathname.replace(/[^A-Za-z]+/g, "") ===
                    "createorder" ||
                  location.pathname.replace(/[^A-Za-z]+/g, "") ===
                    "salereturn" ||
                  location.pathname.replace(/[^A-Za-z]+/g, "") ===
                    "salereturnlist" ||
                  isShown.sale == true
                    ? "#1A5386"
                    : "#fff",
              }}
            >
              <SignalCellularAlt
                style={{
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") === "sale" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "saledetail" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "createorder" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "salereturn" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "salereturnlist" ||
                    isShown.sale == true
                      ? "#fff"
                      : "#1A5386",
                }}
              />
              <a
                style={{
                  textDecoration: "none",
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") === "sale" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "saledetail" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "createorder" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "salereturn" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "salereturnlist" ||
                    isShown.sale == true
                      ? "#fff"
                      : "#1A5386",
                  width: "100%",
                  marginLeft: "1rem",
                }}
                href="/sale"
              >
                <ListItemText
                  primary="Sale"
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") === "sale" ||
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "saledetail" ||
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "createorder" ||
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "salereturn" ||
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "salereturnlist" ||
                      isShown.sale == true
                        ? "#fff"
                        : "#1A5386",
                    fontWeight: "700 !important",
                  }}
                />
              </a>
            </ListItem>



            <ListItem
              onMouseEnter={() => handleMouseEnter("groupreturn")}
              onMouseLeave={() => handleMouseLeave()}
              style={{
                alignItems: "center",
                display: "flex",
                marginBottom: "0",
                padding: "10px 30px",
                borderRadius: "10px",
                backgroundColor:
                  location.pathname.replace(/[^A-Za-z]+/g, "") === "groupreturn" ||
                  isShown.groupreturn == true
                    ? "#1A5386"
                    : "#fff",
              }}
            >
              <Archive
                style={{
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "groupreturn" || isShown.groupreturn == true
                      ? "#fff"
                      : "#1A5386",
                }}
              />
              <a
                style={{
                  textDecoration: "none",
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "groupreturn" || isShown.groupreturn == true
                      ? "#fff"
                      : "#1A5386",
                  width: "100%",
                  marginLeft: "1rem",
                }}
                href="/groupreturn"
              >
                <ListItemText
                  primary="Group Return"
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "groupreturn" || isShown.groupreturn == true
                        ? "#fff"
                        : "#1A5386",
                    fontWeight: "700 !important",
                  }}
                />
              </a>
            </ListItem>



            <ListItem
              onMouseEnter={() => handleMouseEnter("salesyncstatus")}
              onMouseLeave={() => handleMouseLeave()}
              style={{
                alignItems: "center",
                display: "flex",
                marginBottom: "0",
                padding: "10px 30px",
                borderRadius: "10px",
                backgroundColor:
                  location.pathname.replace(/[^A-Za-z]+/g, "") ===
                    "salesyncstatus" || isShown.salesyncstatus == true
                    ? "#1A5386"
                    : "#fff",
              }}
            >
              <Sync
                style={{
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "salesyncstatus" || isShown.salesyncstatus == true
                      ? "#fff"
                      : "#1A5386",
                }}
              />
              <a
                style={{
                  textDecoration: "none",
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "salesyncstatus" || isShown.salesyncstatus == true
                      ? "#fff"
                      : "#1A5386",
                  width: "100%",
                  marginLeft: "1rem",
                }}
                href="/salesyncstatus"
              >
                <ListItemText
                  primary="Sale Sync Status"
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "salesyncstatus" || isShown.salesyncstatus == true
                        ? "#fff"
                        : "#1A5386",
                    fontWeight: "700 !important",
                  }}
                />
              </a>
            </ListItem>

            <ListItem
              onMouseEnter={() => handleMouseEnter("editcart")}
              onMouseLeave={() => handleMouseLeave()}
              style={{
                alignItems: "center",
                display: "flex",
                marginBottom: "0",
                padding: "10px 30px",
                borderRadius: "10px",
                backgroundColor:
                  location.pathname.replace(/[^A-Za-z]+/g, "") === "editcart" ||
                  isShown.editcart == true
                    ? "#1A5386"
                    : "#fff",
              }}
            >
              <ShoppingCart
                style={{
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "editcart" || isShown.editcart == true
                      ? "#fff"
                      : "#1A5386",
                }}
              />
              <a
                style={{
                  textDecoration: "none",
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "editcart" || isShown.editcart == true
                      ? "#fff"
                      : "#1A5386",
                  width: "100%",
                  marginLeft: "1rem",
                }}
                href="/editcart"
              >
                <ListItemText
                  primary="Edit Cart"
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "editcart" || isShown.editcart == true
                        ? "#fff"
                        : "#1A5386",
                    fontWeight: "700 !important",
                  }}
                />
              </a>
            </ListItem>
            <ListItem
              onMouseEnter={() => handleMouseEnter("salereport")}
              onMouseLeave={() => handleMouseLeave()}
              style={{
                alignItems: "center",
                display: "flex",
                marginBottom: "0",
                padding: "10px 30px",
                borderRadius: "10px",
                backgroundColor:
                  location.pathname.replace(/[^A-Za-z]+/g, "") ===
                    "salereport" ||
                  location.pathname.replace(/[^A-Za-z]+/g, "") ===
                    "salereportdetail" ||
                  isShown.salereport == true
                    ? "#1A5386"
                    : "#fff",
              }}
            >
              <Report
                style={{
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "salereport" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "salereportdetail" ||
                    isShown.salereport == true
                      ? "#fff"
                      : "#1A5386",
                }}
              />
              <a
                style={{
                  textDecoration: "none",
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "salereport" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "salereportdetail" ||
                    isShown.salereport == true
                      ? "#fff"
                      : "#1A5386",
                  width: "100%",
                  marginLeft: "1rem",
                  position: "relative",
                }}
                href="/salereport"
              >
                <ListItemText
                  primary="Order with Issue"
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "salereport" ||
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "salereportdetail" ||
                      isShown.salereport == true
                        ? "#fff"
                        : "#1A5386",
                    fontWeight: "700 !important",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    right: "-20%",
                    backgroundColor: "#C52626",
                    width: "25px",
                    height: "15px",
                    borderRadius: "0.25rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#fff",
                    fontSize: "10px",
                    fontWeight: "bold",
                  }}
                >
                  {issuesCount}
                </div>
              </a>
            </ListItem>

            <ListItem
              onMouseEnter={() => handleMouseEnter("returnsyncstatus")}
              onMouseLeave={() => handleMouseLeave()}
              style={{
                alignItems: "center",
                display: "flex",
                marginBottom: "0",
                padding: "10px 30px",
                borderRadius: "10px",
                backgroundColor:
                  location.pathname.replace(/[^A-Za-z]+/g, "") ===
                    "returnsyncstatus" || isShown.returnsyncstatus == true
                    ? "#1A5386"
                    : "#fff",
              }}
            >
              <Sync
                style={{
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "returnsyncstatus" || isShown.returnsyncstatus == true
                      ? "#fff"
                      : "#1A5386",
                }}
              />
              <a
                style={{
                  textDecoration: "none",
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "returnsyncstatus" || isShown.returnsyncstatus == true
                      ? "#fff"
                      : "#1A5386",
                  width: "100%",
                  marginLeft: "1rem",
                }}
                href="/returnsyncstatus"
              >
                <ListItemText
                  primary="Return Sync Status"
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "returnsyncstatus" || isShown.returnsyncstatus == true
                        ? "#fff"
                        : "#1A5386",
                    fontWeight: "700 !important",
                  }}
                />
              </a>
            </ListItem>

            <ListItem
              onMouseEnter={() => handleMouseEnter("inventory")}
              onMouseLeave={() => handleMouseLeave()}
              style={{
                alignItems: "center",
                display: "flex",
                marginBottom: "0",
                padding: "10px 30px",
                borderRadius: "10px",
                backgroundColor:
                  location.pathname.replace(/[^A-Za-z]+/g, "") ===
                    "inventory" ||
                  location.pathname.replace(/[^A-Za-z]+/g, "") ===
                    "inventorydetail" ||
                  isShown.inventory == true
                    ? "#1A5386"
                    : "#fff",
              }}
            >
              <Inventory
                style={{
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "inventory" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "inventorydetail" ||
                    isShown.inventory == true
                      ? "#fff"
                      : "#1A5386",
                }}
              />
              <a
                style={{
                  textDecoration: "none",
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "inventory" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "inventorydetail" ||
                    isShown.inventory == true
                      ? "#fff"
                      : "#1A5386",
                  width: "100%",
                  marginLeft: "1rem",
                }}
                href="/inventory"
              >
                <ListItemText
                  primary="Inventory"
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "inventory" ||
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "inventorydetail" ||
                      isShown.inventory == true
                        ? "#fff"
                        : "#1A5386",
                    fontWeight: "700 !important",
                  }}
                />
              </a>
            </ListItem>
            <ListItem
              onMouseEnter={() => handleMouseEnter("razerlog")}
              onMouseLeave={() => handleMouseLeave()}
              style={{
                alignItems: "center",
                display: "flex",
                marginBottom: "0",
                padding: "10px 30px",
                borderRadius: "10px",
                backgroundColor:
                  location.pathname.replace(/[^A-Za-z]+/g, "") === "razerlog" ||
                  isShown.razerlog == true
                    ? "#1A5386"
                    : "#fff",
              }}
            >
              <History
                style={{
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "razerlog" || isShown.razerlog == true
                      ? "#fff"
                      : "#1A5386",
                }}
              />
              <a
                style={{
                  textDecoration: "none",
                  color:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "razerlog" || isShown.razerlog == true
                      ? "#fff"
                      : "#1A5386",
                  width: "100%",
                  marginLeft: "1rem",
                }}
                href="/razerlog"
              >
                <ListItemText
                  primary="Razer Log"
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "razerlog" || isShown.razerlog == true
                        ? "#fff"
                        : "#1A5386",
                    fontWeight: "700 !important",
                  }}
                />
              </a>
            </ListItem>

            <ListItem
              style={{
                alignItems: "center",
                display: "flex",
                marginBottom: "0",
                cursor: "pointer"
              }}
              onClick={handleClickUser}
            >
              <a
                style={{
                  textDecoration: "none",
                  color: "#1A5386",
                  width: "100%",
                  // marginLeft: "1rem",
                }}
              >
                <ListItemText
                  primary="User Management"
                  style={{
                    color: "#1A5386",
                    fontWeight: "700 !important",
                  }}
                />
              </a>
              {openUser ? (
                <ExpandLess style={{ color: "#1A5386" }} />
              ) : (
                <ExpandMore style={{ color: "#1A5386" }} />
              )}
            </ListItem>
            <Collapse in={openUser} timeout="auto" unmountOnExit>
              <ListItem
                onMouseEnter={() => handleMouseEnter("customer")}
                onMouseLeave={() => handleMouseLeave()}
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  backgroundColor:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "customer" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "customerdetail" ||
                    isShown.customer == true
                      ? "#1A5386"
                      : "#fff",
                }}
              >
                <Group
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "customer" ||
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "customerdetail" ||
                      isShown.customer == true
                        ? "#fff"
                        : "#1A5386",
                  }}
                />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "customer" ||
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "customerdetail" ||
                      isShown.customer == true
                        ? "#fff"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/customer"
                >
                  <ListItemText
                    primary="Customer"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "customer" ||
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "customerdetail" ||
                        isShown.customer == true
                          ? "#fff"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
                
              </ListItem>
              
              <ListItem
                onMouseEnter={() => handleMouseEnter("admin")}
                onMouseLeave={() => handleMouseLeave()}
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  backgroundColor:
                    location.pathname.replace(/[^A-Za-z]+/g, "") === "admin" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "admindetail" ||
                    isShown.admin == true
                      ? "#1A5386"
                      : "#fff",
                }}
              >
                <Group
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "admin" ||
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "admindetail" ||
                      isShown.admin == true
                        ? "#fff"
                        : "#1A5386",
                  }}
                />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "admin" ||
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "admindetail" ||
                      isShown.admin == true
                        ? "#fff"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/admin"
                >
                  <ListItemText
                    primary="Admin"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "admin" ||
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "admindetail" ||
                        isShown.admin == true
                          ? "#fff"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>

              <ListItem
                onMouseEnter={() => handleMouseEnter("changepassword")}
                onMouseLeave={() => handleMouseLeave()}
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  backgroundColor:
                    location.pathname.replace(/[^A-Za-z]+/g, "") === "changepassword" ||
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "changepassword" ||
                    isShown.changepassword == true
                      ? "#1A5386"
                      : "#fff",
                }}
              >
                <Lock
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "changepassword" ||
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "changepassword" ||
                      isShown.changepassword == true
                        ? "#fff"
                        : "#1A5386",
                  }}
                />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "changepassword" ||
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "changepassword" ||
                      isShown.changepassword == true
                        ? "#fff"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/changepassword"
                >
                  <ListItemText
                    primary="Change Password"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "changepassword" ||
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "changepassword" ||
                        isShown.changepassword == true
                          ? "#fff"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>
            </Collapse>

            <ListItem
              style={{
                alignItems: "center",
                display: "flex",
                marginBottom: "0",
                cursor: "pointer"
              }}
              onClick={handleClickSetting}
            >
              <a
                style={{
                  textDecoration: "none",
                  color: "#1A5386",
                  width: "100%",
                  // marginLeft: "1rem",
                }}
              >
                <ListItemText
                  primary="Settings"
                  style={{
                    color: "#1A5386",
                    fontWeight: "700 !important",
                  }}
                />
              </a>
              {openSetting ? (
                <ExpandLess style={{ color: "#1A5386" }} />
              ) : (
                <ExpandMore style={{ color: "#1A5386" }} />
              )}
            </ListItem>
            <Collapse in={openSetting} timeout="auto" unmountOnExit>
              <ListItem
                onMouseEnter={() => handleMouseEnter("shipping")}
                onMouseLeave={() => handleMouseLeave()}
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  backgroundColor:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "shipping" || isShown.shipping == true
                      ? "#1A5386"
                      : "#fff",
                }}
              >
                <LocalShipping
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "shipping" || isShown.shipping == true
                        ? "#fff"
                        : "#1A5386",
                  }}
                />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "shipping" || isShown.shipping == true
                        ? "#fff"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/shipping"
                >
                  <ListItemText
                    primary="Shipping"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "shipping" || isShown.shipping == true
                          ? "#fff"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>
              <ListItem
                onMouseEnter={() => handleMouseEnter("color")}
                onMouseLeave={() => handleMouseLeave()}
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  backgroundColor:
                    location.pathname.replace(/[^A-Za-z]+/g, "") === "color" ||
                    isShown.color == true
                      ? "#1A5386"
                      : "#fff",
                }}
              >
                <ColorLens
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "color" || isShown.color == true
                        ? "#fff"
                        : "#1A5386",
                  }}
                />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "color" || isShown.color == true
                        ? "#fff"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/color"
                >
                  <ListItemText
                    primary="Color"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "color" || isShown.color == true
                          ? "#fff"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>
              <ListItem
                onMouseEnter={() => handleMouseEnter("material")}
                onMouseLeave={() => handleMouseLeave()}
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  backgroundColor:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "material" || isShown.material == true
                      ? "#1A5386"
                      : "#fff",
                }}
              >
                <Checkroom
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "material" || isShown.material == true
                        ? "#fff"
                        : "#1A5386",
                  }}
                />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "material" || isShown.material == true
                        ? "#fff"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/material"
                >
                  <ListItemText
                    primary="Material"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "material" || isShown.material == true
                          ? "#fff"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>
              <ListItem
                onMouseEnter={() => handleMouseEnter("apparel")}
                onMouseLeave={() => handleMouseLeave()}
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  backgroundColor:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "apparel" || isShown.apparel == true
                      ? "#1A5386"
                      : "#fff",
                }}
              >
                <Checkroom
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "apparel" || isShown.apparel == true
                        ? "#fff"
                        : "#1A5386",
                  }}
                />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "apparel" || isShown.apparel == true
                        ? "#fff"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/apparel"
                >
                  <ListItemText
                    primary="Apparel"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "apparel" || isShown.apparel == true
                          ? "#fff"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>
              <ListItem
                onMouseEnter={() => handleMouseEnter("decoration")}
                onMouseLeave={() => handleMouseLeave()}
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  backgroundColor:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "decoration" || isShown.decoration == true
                      ? "#1A5386"
                      : "#fff",
                }}
              >
                <Checkroom
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "decoration" || isShown.decoration == true
                        ? "#fff"
                        : "#1A5386",
                  }}
                />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "decoration" || isShown.decoration == true
                        ? "#fff"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/decoration"
                >
                  <ListItemText
                    primary="Decoration"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "decoration" || isShown.decoration == true
                          ? "#fff"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>
              <ListItem
                onMouseEnter={() => handleMouseEnter("decorative")}
                onMouseLeave={() => handleMouseLeave()}
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  backgroundColor:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "decorative" || isShown.decorative == true
                      ? "#1A5386"
                      : "#fff",
                }}
              >
                <Checkroom
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "decorative" || isShown.decorative == true
                        ? "#fff"
                        : "#1A5386",
                  }}
                />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "decorative" || isShown.decorative == true
                        ? "#fff"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/decorative"
                >
                  <ListItemText
                    primary="Decorative"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "decorative" || isShown.decorative == true
                          ? "#fff"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>
              <ListItem
                onMouseEnter={() => handleMouseEnter("banner")}
                onMouseLeave={() => handleMouseLeave()}
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  backgroundColor:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "banner" || isShown.banner == true
                      ? "#1A5386"
                      : "#fff",
                }}
              >
                <Image
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "banner" || isShown.banner == true
                        ? "#fff"
                        : "#1A5386",
                  }}
                />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "banner" || isShown.banner == true
                        ? "#fff"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/banner"
                >
                  <ListItemText
                    primary="Banner"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "banner" || isShown.banner == true
                          ? "#fff"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>


              <ListItem
                onMouseEnter={() => handleMouseEnter("slider")}
                onMouseLeave={() => handleMouseLeave()}
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  backgroundColor:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "slider" || isShown.slider == true
                      ? "#1A5386"
                      : "#fff",
                }}
              >
                <LinearScale
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "slider" || isShown.slider == true
                        ? "#fff"
                        : "#1A5386",
                  }}
                />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "slider" || isShown.slider == true
                        ? "#fff"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/slider"
                >
                  <ListItemText
                    primary="Best Seller"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "slider" || isShown.slider == true
                          ? "#fff"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>
              <ListItem
                onMouseEnter={() => handleMouseEnter("brand")}
                onMouseLeave={() => handleMouseLeave()}
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  backgroundColor:
                    (location.pathname.replace(/[^A-Za-z]+/g, "") === "settingbrand" ||
                     location.pathname.replace(/[^A-Za-z]+/g, "") === "brand" ||
                     location.pathname.includes("/brand")) || isShown.brand == true
                      ? "#1A5386"
                      : "#fff",
                }}
              >
                <Checkroom
                  style={{
                    color:
                      (location.pathname.replace(/[^A-Za-z]+/g, "") === "settingbrand" ||
                       location.pathname.replace(/[^A-Za-z]+/g, "") === "brand" ||
                       location.pathname.includes("/brand")) || isShown.brand == true
                        ? "#fff"
                        : "#1A5386",
                  }}
                />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      (location.pathname.replace(/[^A-Za-z]+/g, "") === "settingbrand" ||
                       location.pathname.replace(/[^A-Za-z]+/g, "") === "brand" ||
                       location.pathname.includes("/brand")) || isShown.brand == true
                        ? "#fff"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/brand"
                >
                  <ListItemText
                    primary="Brand"
                    style={{
                      color:
                        (location.pathname.replace(/[^A-Za-z]+/g, "") === "settingbrand" ||
                         location.pathname.replace(/[^A-Za-z]+/g, "") === "brand" ||
                         location.pathname.includes("/brand")) || isShown.brand == true
                          ? "#fff"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>
            </Collapse>

            <ListItem
              style={{
                alignItems: "center",
                display: "flex",
                marginBottom: "0",
                cursor: "pointer"
              }}
              onClick={handleClickEnquiry}
            >
              <a
                style={{
                  textDecoration: "none",
                  color: "#1A5386",
                  width: "100%",
                  // marginLeft: "1rem",
                }}
              >
                <ListItemText
                  primary="Enquiry"
                  style={{
                    color: "#1A5386",
                    fontWeight: "700 !important",
                  }}
                />
              </a>
              {openEnquiry ? (
                <ExpandLess style={{ color: "#1A5386" }} />
              ) : (
                <ExpandMore style={{ color: "#1A5386" }} />
              )}
            </ListItem>
            <Collapse in={openEnquiry} timeout="auto" unmountOnExit>
              <ListItem
                onMouseEnter={() => handleMouseEnter("custommadeenquiry")}
                onMouseLeave={() => handleMouseLeave()}
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  backgroundColor:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "custommadeenquiry" || isShown.custommadeenquiry == true
                      ? "#1A5386"
                      : "#fff",
                }}
              >
                <Forum
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "custommadeenquiry" || isShown.custommadeenquiry == true
                        ? "#fff"
                        : "#1A5386",
                  }}
                />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "custommadeenquiry" || isShown.custommadeenquiry == true
                        ? "#fff"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/custommadeenquiry"
                >
                  <ListItemText
                    primary="Custom Made Enquiry"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "custommadeenquiry" ||
                        isShown.custommadeenquiry == true
                          ? "#fff"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>
              <ListItem
                onMouseEnter={() => handleMouseEnter("customerenquiry")}
                onMouseLeave={() => handleMouseLeave()}
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  backgroundColor:
                    location.pathname.replace(/[^A-Za-z]+/g, "") ===
                      "customerenquiry" || isShown.customerenquiry == true
                      ? "#1A5386"
                      : "#fff",
                }}
              >
                <Message
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "customerenquiry" || isShown.customerenquiry == true
                        ? "#fff"
                        : "#1A5386",
                  }}
                />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "customerenquiry" || isShown.customerenquiry == true
                        ? "#fff"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/customerenquiry"
                >
                  <ListItemText
                    primary="Customer Enquiry"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "customerenquiry" || isShown.customerenquiry == true
                          ? "#fff"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>
            </Collapse>

            {/* <ListItem
              style={{
                alignItems: "center",
                display: "flex",
                marginBottom: "0",
              }}
              onClick={handleClick}
            >
              <a
                style={{
                  textDecoration: "none",
                  color: "#1A5386",
                  width: "100%",
                }}
              >
                <ListItemText
                  primary="UI Management"
                  style={{
                    color: "#1A5386",
                    fontWeight: "700 !important",
                  }}
                />
              </a>
              {open ? (
                <ExpandLess style={{ color: "#1A5386" }} />
              ) : (
                <ExpandMore style={{ color: "#1A5386" }} />
              )}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <ListItem
                onMouseEnter={() => handleMouseEnter("banner")}
                onMouseLeave={() => handleMouseLeave()}
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  backgroundColor:
                    location.pathname.replace(/[^A-Za-z]+/g, "") === "banner" ||
                    isShown.banner == true
                      ? "#1A5386"
                      : "#fff",
                }}
              >
                <ViewCarousel
                  style={{
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "banner" || isShown.banner == true
                        ? "#fff"
                        : "#1A5386",
                  }}
                />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") ===
                        "banner" || isShown.banner == true
                        ? "#fff"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/banner"
                >
                  <ListItemText
                    primary="Banner"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") ===
                          "banner" || isShown.banner == true
                          ? "#fff"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>
            </Collapse> */}

            <div className={classes.theHidee}>
              <br />
              <ListItem
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                }}
              >
                <ShoppingCart style={{ color: "#1A5386" }} />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") === ""
                        ? "#FF9200"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/"
                >
                  <ListItemText
                    primary="Shopping Cart"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") === ""
                          ? "#FF9200"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>
              <ListItem
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                }}
              >
                <Notifications style={{ color: "#1A5386" }} />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") === ""
                        ? "#FF9200"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/"
                >
                  <ListItemText
                    primary="Notifications"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") === ""
                          ? "#FF9200"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>
              <ListItem
                style={{
                  alignItems: "center",
                  display: "flex",
                  marginBottom: "0",
                }}
              >
                <Logout style={{ color: "#1A5386" }} />
                <a
                  style={{
                    textDecoration: "none",
                    color:
                      location.pathname.replace(/[^A-Za-z]+/g, "") === ""
                        ? "#FF9200"
                        : "#1A5386",
                    width: "100%",
                    marginLeft: "1rem",
                  }}
                  href="/"
                >
                  <ListItemText
                    primary="Logout"
                    style={{
                      color:
                        location.pathname.replace(/[^A-Za-z]+/g, "") === ""
                          ? "#FF9200"
                          : "#1A5386",
                      fontWeight: "700 !important",
                    }}
                  />
                </a>
              </ListItem>
            </div>
          </List>
        )}

        {/* <Divider /> */}
      </Box>
    </div>
  );

  return (
    <Box sx={{ display: "flex" }}>
      {/* <CssBaseline /> */}
      <AppBar
        position="fixed"
        sx={{
          ml: { md: `${drawerWidth}px` },
          zIndex: (theme) => theme.zIndex.drawer + 1,
          background: "#FFF",
          padding: "0 2rem",
        }}
      >
        <Toolbar>
          <IconButton
            color="#1A5386"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 1, display: { md: "none" } }}
          >
            <MenuIcon style={{ color: "#1A5386" }} />
          </IconButton>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className={classes.theNavBox}></div>
            <div className={classes.theNavBox_}>
              {/* <NavbarLink color="#1A5386">
                <Notifications style={{ color: "#1A5386" }} />
              </NavbarLink> */}
              <NavbarLink color="#1A5386" onClick={() => handleLogout()}>
                <Person style={{ color: "#1A5386", marginRight: ".4rem" }} />
                Logout
              </NavbarLink>
            </div>
          </div>
        </Toolbar>
      </AppBar>

      <Drawer
        // container={container}
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          // width: {xs: "0px", md: drawerWidth},
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            backgroundColor: "#FFF",
            boxSizing: "border-box",
            width: drawerWidth,
            borderRight: "unset",
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          width: { xs: "0px", md: drawerWidth },
          display: { xs: "none", md: "block" },
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "#FFF",
            borderRight: "unset",
            boxShadow: "  0px 4px 5px 0px rgb(0 0 0 / 20%)",
          },
        }}
        open
      >
        {drawer}
      </Drawer>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: "auto",
          // padding: { xs : `3rem 1rem`, md: `3rem` },
          width: { md: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default Navbar2;
